import toast from "react-hot-toast";
import { t } from "i18next";
import { logApiError, getErrorType, API_ERROR_TYPES } from "../../utils/apiErrorHandler";

const handleTokenExpire = (item, status) => {
  if (status === 401) {
    if (window.localStorage.getItem("token")) {
      toast.error(t("Your token has been expired.please sign in again"));
      window?.localStorage.removeItem("token");
      window.location.href = "/auth/sign-in";
    }
  } else if (status !== 429 && status !== 403) {
    // Don't show toast for rate limiting errors and 403 forbidden errors
    toast.error(item?.message, {
      id: "error",
    });
  }
};

export const onErrorResponse = (error) => {
  const errorType = getErrorType(error);
  
  // Log the error for debugging
  logApiError(error, 'API Request');
  
  // Don't show toast notifications for rate limiting and 403 forbidden errors
  if (errorType === API_ERROR_TYPES.RATE_LIMIT || error?.response?.status === 403) {
    return;
  }
  
  if (Array.isArray(error?.response?.data?.errors)) {
    error?.response?.data?.errors?.forEach((item) => {
      handleTokenExpire(item, error?.response?.status);
    });
  }
};
export const onSingleErrorResponse = (error) => {
  const errorType = getErrorType(error);
  
  // Log the error for debugging
  logApiError(error, 'Single API Request');
  
  // Don't show toast notifications for rate limiting and 403 forbidden errors
  if (errorType === API_ERROR_TYPES.RATE_LIMIT || error?.response?.status === 403) {
    return;
  }
  
  toast.error(error?.response?.data?.message, {
    id: "error",
  });
  handleTokenExpire(error, error?.response?.status);
};
